export enum PolicyFileType {
    cookie = "cookiePolicy",
    privacy = "privacyPolicy",
    terms = "termsOfUse",
}
